import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const AdminPage = () => {
  return (
    <Container fluid>
      <Row>
        <Col>
          <h1 className="h3 mb-4">Admin Panel</h1>
          <Card>
            <Card.Body className="text-center py-5">
              <i className="fas fa-shield-alt text-muted mb-3" style={{ fontSize: '3rem' }}></i>
              <h5 className="text-muted">Admin Page</h5>
              <p className="text-muted">This page will contain admin tools and user management.</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminPage;
